import * as React from 'react';

const goldenStarSvg: JSX.Element = (
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 18.2884L16.882 21.7078C17.6335 22.1852 18.5872 21.5165 18.3946 20.6473L16.948 14.12L21.8193 9.67788C22.4624 9.09146 22.1013 8.02035 21.2344 7.94294L14.872 7.37474L12.4276 1.30387C12.0913 0.468538 10.9087 0.468539 10.5724 1.30387L8.128 7.37474L1.76555 7.94294C0.898692 8.02035 0.537616 9.09146 1.1807 9.67788L6.052 14.12L4.6054 20.6473C4.41277 21.5165 5.36652 22.1852 6.11796 21.7078L11.5 18.2884Z" fill="#FDD72F" />
  </svg>
);

export default goldenStarSvg;
